import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a057467f6558f001414d9dd/teachertrack/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a057467f6558f001414d9dd/teachertrack/src/app/components/AttendanceRecordsTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a057467f6558f001414d9dd/teachertrack/src/app/components/DashboardCharts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a057467f6558f001414d9dd/teachertrack/src/app/components/DashboardHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a057467f6558f001414d9dd/teachertrack/src/components/Sidebar.tsx");
